import { Component, inject } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-terms-and-conditions-modal',
  imports: [
    TranslocoPipe
  ],
  templateUrl: './terms-and-conditions-modal.html',
  styleUrl: './terms-and-conditions-modal.scss'
})
export class TermsAndConditionsModal {
  private readonly ref = inject(DynamicDialogRef);

  protected acceptAndClose(): void {
    this.ref.close();
  }
}
